import { Button, CircularProgress, Input, InputLabel } from "@mui/material"
import styles from "./UnpaidLicense.module.css"
import { useEffect, useState } from "react"
import UnpaidLicenseTable from "../../components/UnpaidLicenseTable/UnpaidLicenseTable"
import { useApi } from "../../hooks/useApi"

export default function UnpaidLicense() {
    const { getUnpaidLicenses } = useApi()
    const [data, setData] = useState<[] | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(true)

    useEffect(() => {
        async function handleFetch() {
            const result = await getUnpaidLicenses();
            if (result) {
                setData(result.response)
            }
            setIsLoading(false)
        }
        handleFetch()
    }, [])

    return (<>
        <h1 className={styles.h1}>Licences Impayées</h1>
        { isLoading && 
            <div className={styles.circularProgressBox}>
                <CircularProgress />
            </div>        
        }
        {data && <UnpaidLicenseTable data={data} />}
    </>)
}